export default __webpack_public_path__ + "static/media/rasha.440c5113.svg";